import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PendingIcon from "@mui/icons-material/Pending";
import { Theme } from "@mui/material";

export type StatusType = "approved" | "rejected" | "pending";

export const getStatusColor = (
  status: string | undefined,
): "success" | "error" | "warning" => {
  switch (status) {
    case "approved":
      return "success";
    case "rejected":
      return "error";
    default:
      return "warning";
  }
};

export const getStatusIcon = (status: string | undefined, theme: Theme) => {
  const color =
    theme.palette[getStatusColor(status) as "success" | "error" | "warning"]
      .main;

  switch (status) {
    case "approved":
      return <CheckCircleIcon fontSize="small" sx={{ color }} />;
    case "rejected":
      return <CancelIcon fontSize="small" sx={{ color }} />;
    default:
      return <PendingIcon fontSize="small" sx={{ color }} />;
  }
};

export const formatStatusText = (status: string | undefined): string => {
  const statusText = status || "pending";
  return statusText.charAt(0).toUpperCase() + statusText.slice(1).toLowerCase();
};
